import React from "react";
import Logo from "../../assets/hyperthings-logo.svg";
import "./layout.css"; // Assuming you created a CSS file for styling
import Slider from "./Slider/Slider";
import Footer from "./Footer";

export default function BasicLayout({ children }) {
  return (
    <div>
      <div className="logo">
        <img src={Logo} alt="Hyperthings Logo" className="logo-img" />
      </div>
      <div className="row">
        {/* Column 1 */}
        <div className="column-sub-content">
          <div className="card-view">
            <Slider />
          </div>
        </div>
   
        {/* Column 2 */}
        <div className="column-main-content">
          <div>{children}</div>
        </div>
      </div>
      <Footer />

    </div>
  );
}
